import { Object3D } from 'three';
import { Command } from '../command.js';
import { Editor } from '../editor.js';

/**
 * @param editor Editor
 * @param object THREE.Object3D
 * @param attributeName string
 * @param newValue number, string, boolean or object
 * @constructor
 */
class SetValueCommand<T extends Object3D,K extends keyof T> extends Command {
	object:T;
	attributeName:K;
	oldValue:any;
	newValue:any;
	constructor( editor:Editor, object:T, attributeName:K, newValue:any ) {

		super( editor );

		this.type = 'SetValueCommand';
		this.name = `Set ${attributeName.toString()}`;
		this.updatable = true;

		this.object = object;
		this.attributeName = attributeName;
		this.oldValue = ( object !== undefined ) ? object[ attributeName ] : undefined;
		this.newValue = newValue;

	}

	execute() {

		this.object[ this.attributeName ] = this.newValue;
		this.editor.signals.objectChanged.dispatch( this.object );
		// this.editor.signals.sceneGraphChanged.dispatch();

	}

	undo() {

		this.object[ this.attributeName ] = this.oldValue;
		this.editor.signals.objectChanged.dispatch( this.object );
		// this.editor.signals.sceneGraphChanged.dispatch();

	}

	update( cmd:SetValueCommand<T,K> ) {

		this.newValue = cmd.newValue;

	}

}

export { SetValueCommand };
